import { isGroupNavItem } from "./index";
import { type SingleLineMenu } from "../types";
import { getPageNavBarItems } from "./getPageNavBarItems";

export function getSingleLineActiveGroupItem(
  pathname: string,
  menuItems: SingleLineMenu,
) {
  return menuItems.filter(isGroupNavItem).find((groupItem) =>
    getPageNavBarItems(groupItem.subMenuItems).find((subItem) => {
      return pathname.endsWith(subItem.url);
    }),
  );
}
